export enum CustomerGroup {
  Default = '',
  DefaultInPreparation = 'default_in_preparation',
  DEFAULT_WEB_APP = 'default_web_app',
  Subway = 'subway',
  SubwayFr = 'subway_fr',
  SubwayLu = 'subway_lu',
  SubwayTerminal = 'subway_terminal',
  DB = 'db',
  Lunchroom = 'lunchroom',
  FoodByFriends = 'foodbyfriends',
  Weilands = 'weilands',
  Cinemaxx = 'cinemaxx',
  District = 'district',
  Slush = 'slush',
  Kochloeffel = 'kochloeffel',
  Immergruen = 'immergruen',
  MyMonza = 'mymonza',
  Aspasia = 'aspasia',
  Cotidiano = 'cotidiano',
  Bigburger = 'bigburger',
  KOOS = 'koos',
  Frittenwerk = 'frittenwerk',
  Ottosburger = 'ottosburger',
  Purino = 'purino',
  DeanAndDavid = 'dean_and_david',
  ThreeMensKebab = '3menskebab',
  PerfectDay = 'perfectday',
  Hausmanns = 'hausmanns',
  Doenerwerk = 'doenerwerk',
  Foodlounge = 'foodlounge',
  Mado = 'mado',
  Nordsee = 'nordsee',
  Depot = 'depot',
  Jamies = 'jamies',
  BurgerKing = 'burger_king',
  BurgerKingD = 'burger_king_d',
  Saray = 'saray',
  Moschmosch = 'moschmosch',
  Starbucks = 'starbucks',
  Kamps = 'kamps',
  Coffee_Fellows = 'coffee_fellows',
  Hofbrauhaus = 'hofbrauhaus',
  Atlantik_Fisch = 'atlantik_fisch',
  DIMATEST = 'dima_test',
  MALOA = 'maloa',
  WERK5 = 'werk5',
  EPI = 'epi',
  IAMLOVE = 'iamlove',
  BEETS_AND_ROOTS = 'beets_and_roots',
  BEETS_AND_ROOTS_SECOND = 'beets_and_roots_second',
  LOSTERIA = 'losteria',
  LOSTERIA_AT = 'losteria_at',
  SHISO = 'shiso',
  SNACK_ELIZE = 'snack_elize',
  TABILO = 'tabilo',
  TABILO_SIM = 'tabilo_sim',
  TUR_ABNAHME_RES = 'tur_abnahme_res',
  TUR_ABNAHME_SIM = 'tur_abnahme_sim',
  EFFE_GOLD = 'effe_gold',
  LACANTINE = 'lacantine',
  EAM = 'eam',
  NAUPAKA = 'naupaka',
  SPORTSBAR = 'sportsbar',
  CIGKOFTEM = 'cigkoftem',
  SUSHISUPPLY = 'sushisupply',
  THE_ASH = 'the_ash',
  MARKTHALLE = 'markthalle',
  SASHIMI = 'sashimi',
  BONBONCHA = 'bonboncha',
  HULALA = 'hulala',
  BACKWERK_SCHWEIZ = 'backwerk_schweiz',
  BACKWERK_CH = 'backwerk_ch',
  BACKFACTORY = 'backfactory',
  TEEDELI = 'teedeli',
  WOHLFUHLER = 'wohlfuhler',
  FRITTENWERK_SECOND = 'frittenwerk_second',
  ASIA_GOURMET = 'asia_gourmet',
  RICE_REPUBLIC = 'rice_republic',
  GOODBYTZ = 'goodbytz',
  PIRATEN_BURGER = 'piraten_burger',
  TOURNESOL = 'tournesol',
  BREZEL_KOENIG = 'brezel_koenig',
  VINCENT_VEGAN = 'vincent_vegan',
  PAPAIS = 'papais',
  THE_CUP = 'the_cup',
  MARSEILLE_FOOD_MARKET = 'marseille_food_market',
  OLEARYS = 'olearys',
  ICELAND = 'iceland',
  TABLE_DOT = 'table_dot',
  SEVEN_BY_BAT = 'seven_by_bat',
  BREAK_BURGER = 'break_burger',
  WOK = 'wok',
  OAKBERRY = 'oakberry',
  TUR_AUTOHOF = 'tur_autohof',
  TUR_ABNAHME_AUTOHOF = 'tur_abnahme_autohof',
  TRZ = 'trz',
  MONKEY_BURGER = 'monkey_burger',
  PASTA_FEE = 'pasta_fee',
  POTATOE = 'potatoe',
  PIBOSA = 'pibosa',
  SHIANG_MING = 'shiang_ming',
  ANTON_AND_ANNI = 'anton_and_anni',
  KAISIN = 'kaisin',
  DUNKIN = 'dunkin',
  SUSHI_TOMO = 'sushi_tomo',
  SPIGA = 'spiga',
  RASTPARK = 'rastpark',
  AHOI = 'ahoi',
  EATDOORI = 'eatdoori',
  BURRO_BURRO = 'burro_burro',
  BRAMMIBAL_DONUTS = 'brammibal_donuts',
  MILANO_VICE = 'milano_vice',
  SSP_SLICE_IT = 'ssp_slice_it',
  KELADAMS_KEBAB = 'keladams_kebab',
  AUTOHOF24 = 'autohof24',
  REISHAUER = 'reishauer',
  PASTA_LICH = 'pasta_lich',
  EINTRACHT_FRANKFURT = 'eintracht_frankfurt',
  TOPGOLF = 'topgolf',
  KLAUS_KEBAB = 'klaus_kebab',
  JOSEFS = 'josefs',
  BURRITO_COMPANY = 'burrito_company',
  ZERO_KEBAB = 'zero_kebab',
  NHAS_CITY_CHICKEN = 'nhas_city_chicken',
  MR_SHA = 'mr_sha',
  BOLLWERK = 'bollwerk',
  TUR_SEGAFREDO = 'tur_segafredo',
  WYNIGER = 'wyniger',
  BURGER_VISION = 'burger_vision',
  PICKL_BURGER = 'pickl_burger',
  MAISON_MATCHA = 'maison_matcha',
  ENRIQUE_TOMAS = 'enrique_tomas',
  VERSAILLES_CASTLE = 'versailles_castle',
  RANDYS = 'randys',
  SAZ = 'saz',
  HAWAIIAN_POKE_BOWLS = 'hawaiian_poke_bowls',
  LUCA = 'luca',
  OLEARYS_NORDIC = 'olearys_nordic',
  TRATTORIA_TAVOLARE = 'trattoria_tavolare',
  CARLSBERG_SPORTS_BAR = 'carlsberg_sports_bar',
  BISTRO = 'bistro',
  JOMFRUIN = 'jomfruin',
  RABBAGAST = 'rabbagast',
  CRAFT_N_DRAFT = 'craft_n_draft',
  HERFRA = 'herfra',
  CAFE_RITAZZA = 'cafe_ritazza',
  HEINEKEN = 'heineken',
  LA_BOUTIQUE = 'la_boutique',
  VAERBITT = 'vaerbitt',
  ORIGINAL_CHICKEN = 'original_chicken',
  TIGERSTADEN = 'tigerstaden',
  BJORNS_BACKYARD = 'bjorns_backyard',
  BURGER_KING_CH = 'burger_king_ch',
  GELATO_BAR = 'gelato_bar',
  SSP_VINCENT_VEGAN = 'ssp_vincent_vegan',
  EL_KIOSKO = 'el_kiosko',
  SPARE_RIB = 'spare_rib',
  LUCULLUS = 'lucullus',
  BONBIRD = 'bonbird',
  SSP_PIZZA_HUT = 'ssp_pizza_hut',
  ELEVEN_BAR = '11_bar',
  THE_KISSING_GATES = 'the_kissing_gates',
  CAMDEN = 'camden',
  PIZZA_HUT = 'pizza_hut',
  GAMBRINUS = 'gambrinus',
  TABERNNUS = 'tabernnus',
  JIMIS = 'jimis',
  HENSSLER_AT_HOME = 'henssler_at_home',
  DAILY_PIZZA = 'daily_pizza',
  HUNTER_BAR = 'hunter_bar',
  MOGA_TEE = 'moga_tee',
  GRAUHOLZ = 'grauholz',
  WILD_CHILD_COFFEE = 'wild_child_coffee',
  SODAI = 'sodai',
  FIGLMUELLER = 'figlmueller',
  DOMINOS_SWITZERLAND = 'dominos_switzerland',
  AS_FOOD_COMPANY = 'as_food_company',
  SMASH_KOENIG = 'smash_koenig',
  SCHURTER = 'schurter',
  DIRTY_PATTY = 'dirty_patty',
  CAPTAIN_HOOK = 'captain_hook',
  INGERSLEVS = 'ingerslevs',
  THAQI_CAFE_NUERNBERG = 'thaqi_cafe_nuernberg',
  ARAMARK_ASIAN_BISTROT_CONCEPT = 'aramark_asian_bistrot_concept',
  THE_BAB = 'the_bab',
  LOCO_CHICKEN = 'loco_chicken',
  EATERY_77 = 'eatery_77',
  BESHLE = 'beshle',
  FEASTY = 'feasty',
  KANTINE_11 = 'kantine_11',
}
